import * as TE from 'fp-ts/es6/TaskEither'
import * as O from 'fp-ts/es6/Option'
import { useApolloClient } from '@apollo/client'
import { useEffect, useState } from 'react'
import { pipe } from 'fp-ts/es6/pipeable'
import { Invitation, submitBulkUserInvites } from './bulk_invite_logic'
import { PartnerAccountId } from '@amzn/aapn-type-guards'
import { useLoginContext } from 'stagedive/LoginContext'

export interface BulkInviteHookState {
  data: string[] | undefined
  errors: Error[] | undefined
  loading: boolean
}

export function useBulkInviteUsers(invitations: Invitation[], completionHook: () => void, invitesSentWithErrors: () => void): BulkInviteHookState {
  const [state, setState] = useState<BulkInviteHookState>({
    data: undefined,
    errors: undefined,
    loading: true,
  })
  const apolloClient = useApolloClient()

  const { loginContext } = useLoginContext()
  const partnerAccountId = O.getOrElse(() => '')(loginContext.partnerProfileId) as PartnerAccountId
  useEffect(() => {
    pipe(
      invitations,
      (_) => submitBulkUserInvites(apolloClient, invitations, partnerAccountId, invitesSentWithErrors),
      TE.fold(
        (e: Error[]) => {
          return async () =>
            setState({
              data: undefined,
              errors: e,
              loading: false,
            })
        },
        (r) => {
          return async () => {
            completionHook()
            return setState({ data: r, errors: undefined, loading: false })
          }
        },
      ),
    )()
  }, [apolloClient, invitations, partnerAccountId, completionHook])

  return { ...state }
}
